import { render, staticRenderFns } from "./ApplicationChooser.vue?vue&type=template&id=1919f4a2&scoped=true"
import script from "./ApplicationChooser.vue?vue&type=script&lang=js"
export * from "./ApplicationChooser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1919f4a2",
  null
  
)

export default component.exports